import React, { useEffect, useState } from "react";
import LeftMenu from "../AnalyticsModule/Left";
import Table from "../../ui/datatable/DataTable";
import SubLeftMenu from "../AnalyticsModule/SubLeft";
import { useGetNoVoterMarkedACsMutation } from "../../services/announceElection";
import Button from "../../library/components/Button";
import ConfirmationModal from "../../library/components/FileUpload/ConfirmationModal/ConfirmationModal";
import CustomModal from "../../library/components/Modal/modal";

const ListOfNoVoterMarked = () => {
  const [tableData, settableData] = useState([]);
  const [totalNoOfRecords, setTotalNoOfRecords] = useState();
  const [data, datap] = useGetNoVoterMarkedACsMutation();
  const [postdata, dataU] = useGetNoVoterMarkedACsMutation();
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [getac,setacNo] = useState()
  const columns = [
    {
      Header: "S.No",
      accessor: "S_No",
    },
    {
      Header: "Assembly Constituency No and Name",
      accessor: "stateCd",
    },
    {
      Header: "Action",
      accessor: "rollback_marked_ac",
    },
  ];

  useEffect(() => {
    data({
      acNo: "",
      flag: "",
    });
  }, []);

  useEffect(() => {
    if (dataU.isSuccess) {
      data({
        acNo: "",
        flag: "",
      });
      setShowConfirmationPopup(false);
      setacNo()
    }
  }, [dataU.isSuccess]);

  useEffect(() => {
    if (datap.isSuccess) {
      let table = [];
      datap?.data?.payload?.map((item, i) => {
        table.push({
          S_No: i + 1,
          stateCd: `${item.acNo} - ${item.acName}`,
          rollback_marked_ac: (
            <Button
            btnClass="btn-reset"
              value="RESET"
              name = {item?.acNo}
              onClick={(e) => {
                updateDetails(e);
              }}
            />
          ),
        });
        settableData(table);
        setTotalNoOfRecords(datap?.data?.payload?.length)
      });
    }

    if (datap.isError) {
      settableData([]);
    }
  }, [datap.isSuccess, datap.isError]);

  const updateDetails=(e)=>{
    setShowConfirmationPopup(true)
    var temp = e?.target?.name
    setacNo(temp)
  }

  return (
    <SubLeftMenu>
      <CustomModal
        className="confirmation_modal"
        show={showConfirmationPopup}
        onClose={() => {
          setShowConfirmationPopup(false);
        }}
        size="500px"
        closeIcon={false}
        modalTitle={"Do you want to Reset ?"}
        children={
          <div>
            <ConfirmationModal
              // title="You want to delete this"
              noOption={() => {
                setShowConfirmationPopup(false);
              }}
              yesOption={() => {
                postdata({
                  acNo: getac,
                  flag: "Y",
                });
              }}
            />
          </div>
        }
      />
      <div className="container box shadow ">
      <div className="checkboxHeader">
        <p className="text-center checkboxHead">
          Assembly Constituency List With No Service Voter
        </p>
      </div>
      <div className="my-4">
        <Table
          placeholder="Search"
          globalsearch={true}
          selectall={true}
          columns={columns}
          emptyMessage="No Record Found"
          data={tableData?.length === 0 ? [] : tableData}
          size={10}
          tableClassNameCheck="contenttable-eroll"
          pagination
          records
          gotopage
          rows
          numberrows={totalNoOfRecords}
        />
      </div>
      </div>
    </SubLeftMenu>
  );
};

export default ListOfNoVoterMarked;
